import React, { useMemo, useState } from "react";
import CardHeader from "./common/CardHeader.jsx";
import Card from "./common/Card.jsx";
import useFetch from "../hooks/useFetch.js";
import {
  subtractDays,
  subtractMonth,
  subtractYears,
  yearMonthDate,
} from "../helper/index.js";
import PhoneIcon from "../assets/icons/PhoneIcon";
import SheildIcon from "../assets/icons/SheildIcon";
import UserGroupPeople from "../assets/icons/UserGroupPeople";
import TinyCharts from "../assets/icons/TinyCharts";
import TinyCharts2 from "../assets/icons/TinyCharts2.jsx";
import withLoadingError from "../helper/HOC/withLoadingError.js";
import CustomTab from "./common/CustomTab.jsx";
import FilterComponent from "./common/FilterComponent.jsx";

function Widget({ icon, title, info }) {
  const useStyle = () => {
    return {
      containerStyle: {
        display: "flex",
        padding: "24px",
        borderRadius: "12px",
        background: "#FFF",
        margin: "16px 16px 0 0",
        width: "calc((100%) / 3 - 32px)",
        alignItems: "center",
      },
      header: {
        color: "#362B73",
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        letterSpacing: "0.12px",
        margin: 8,
        opacity: 0.56,
      },
      info: {
        color: "#362B73",
        fontFamily: "Inter",
        fontSize: "22px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "24px",
        margin: 8,
      },
      content: {
        marginLeft: 8,
      },
    };
  };

  const styles = useStyle();

  return (
    <div style={styles.containerStyle}>
      <div>{icon}</div>
      <div style={styles.content}>
        <h1 style={styles.header}>{title}</h1>
        <p style={styles.info}>{info}</p>
      </div>
    </div>
  );
}

const Composer = ({ data }) => {
  const config = [
    { title: "Total Leads", info: data.total_lead, icon: <PhoneIcon /> },
    {
      title: "Lead Converted",
      info: data.lead_converted,
      icon: <SheildIcon />,
    },
    { title: "Total MAOs", info: data.mao_count, icon: <UserGroupPeople /> },
    {
      title: "Conversion Rate",
      info: data.conversion_percentage + " %",
      icon: <TinyCharts />,
    },
    {
      title: "Target vs Achievement",
      info: data.target_vs_achievement + " %",
      icon: <TinyCharts2 />,
    },
  ];

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {config.map((e) => (
        <Widget {...e} key={e.title} />
      ))}
    </div>
  );
};

export default function TeamOverview() {
  const url = `${process.env.REACT_APP_API_URL}/api/online/v1/lead-info`;
  const [tabIndex, setTabIndex] = React.useState(0);
  const [params, setParams] = useState({
    start_time: new Date(),
    end_time: new Date(),
  });

  const handleEndDateChange = (idx) => () => {
    if (idx === 0) {
      setParams({
        start_time: new Date(),
        end_time: new Date(),
      });
    } else if (idx === 1) {
      const end = new Date();
      const start = subtractDays(end, 7);
      setParams({
        start_time: start,
        end_time: end,
      });
    } else if (idx === 2) {
      const end = new Date();
      const start = subtractMonth(end, 1);
      setParams({
        start_time: start,
        end_time: end,
      });
    } else if (idx === 3) {
      const end = new Date();
      const start = subtractYears(end, 1);
      setParams({
        start_time: start,
        end_time: end,
      });
    }
  };

  const tabConfig = [
    { label: "Daily", action: handleEndDateChange(0) },
    { label: "Weekly", action: handleEndDateChange(1) },
    { label: "Monthly", action: handleEndDateChange(2) },
    { label: "Yearly", action: handleEndDateChange(3) },
  ];

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  const handleDateChange = (startDate, endDate) => {
    setParams({
      ...params,
      start_time: startDate,
      end_time: endDate,
    });

    setTabIndex(null);
  };

  const handleResetClick = () => {
    setParams({
      start_time: new Date(),
      end_time: new Date(),
    });
  };

  const processdParams = useMemo(() => {
    const { start_time, end_time } = params;
    return {
      ...params,
      start_time: yearMonthDate(start_time),
      end_time: yearMonthDate(end_time),
    };
  }, [params]);

  const dataState = useFetch(url, processdParams);
  const Overview = withLoadingError(Composer);

  return (
    <Card>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <CardHeader text="Team Overview" />
        <CustomTab
          config={tabConfig}
          tabIndex={tabIndex}
          onTabChange={handleTabChange}
        />
      </div>
      <FilterComponent
        options={{ date: true, reset: true }}
        params={params}
        onDateChange={handleDateChange}
        handleResetClick={handleResetClick}
      />

      <Overview {...dataState} />
    </Card>
  );
}
